import {
  LOADING_DATA_ON_PAGE_LOAD,
  BOARD_NOT_FOUND,
  RECEIVE_BOARD_SHARE_ID
} from "../modules/savedItems/constants";
import { ITEMS_TYPE_SHARED_BOARD } from "../../constants";
import { SET_ITEMS_TYPE } from "../modules/common/constants";
import { getUserIdentity } from "../modules/identity/actions";

export const initialiseBoardNotFound =
  ({ shareId }) =>
  async dispatch => {
    dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: true });
    dispatch({
      type: SET_ITEMS_TYPE,
      payload: { itemsType: ITEMS_TYPE_SHARED_BOARD }
    });
    dispatch({
      type: RECEIVE_BOARD_SHARE_ID,
      payload: { shareId }
    });
    dispatch({
      type: BOARD_NOT_FOUND
    });
    dispatch({ type: LOADING_DATA_ON_PAGE_LOAD, payload: false });
    dispatch(await getUserIdentity());
  };
